(function(app) {

    app.directive("fileExtensionImage",
        function() {
            return {
                restrict: "A",
                scope: {
                    fileName: "=fileExtensionImage"
                },
                link: function (scope, elem) {
                    scope.$watch("fileName",
                        function () {
                            updateExtension();
                        });

                    function updateExtension() {
                        var fileExtension = scope.fileName.split(".").pop().toLowerCase();

                        switch (fileExtension) {
                            case "pdf":
                                elem.attr("src", "Images/Icons/File-Pdf-Icon-Md.svg");
                                break;
                            case "doc":
                            case "docx":
                                elem.attr("src", "Images/Icons/File-Doc-Icon-Md.svg");
                                break;
                            case "xls":
                            case "xlsx":
                                elem.attr("src", "Images/Icons/File-Xls-Icon-Md.svg");
                                break;
                            case "ppt":
                            case "pps":
                            case "pptx":
                                elem.attr("src", "Images/Icons/File-Ppt-Icon-Md.svg");
                                break;
                            case "png":
                            case "jpg":
                            case "jpeg":
                                elem.attr("src", "Images/Icons/File-Img-Icon-Md.svg");
                                break;
                            default:
                                elem.attr("src", "Images/Icons/File-Generic-Icon-Md.svg");
                                break;
                        }
                    }
                }
            };
        });

})(window.app); //jshint ignore:line